import {isNotEmpty} from 'ramda';

import {CARVAGO_URL} from '../../../constants/carvagoUrl';
import {REDIRECT_KEY, REDIRECT_SOURCE} from '../consts/REDIRECT_SOURCE';
import {VehicleData} from '../types/VehicleData';
import {composeQueryParams} from './composeQueryParams';
import {getFilters} from './getFilters';

export const getCarvagoUrl = (vehicleData: VehicleData) => {
  const filters = getFilters(vehicleData);

  const parameters = composeQueryParams(filters.strictFilters, [
    'model',
    'registration-date-from',
    'registration-date-to',
    'fuel-type',
    'power-from',
    'power-to',
    'power-unit',
    'transmission',
    'mileage-to',
  ]);

  const commonParameters = composeQueryParams({[REDIRECT_KEY]: REDIRECT_SOURCE});

  const allParameters = [...parameters, ...commonParameters];

  const link = isNotEmpty(parameters)
    ? `${CARVAGO_URL}/cars?${allParameters.join('&')}`
    : `${CARVAGO_URL}?${commonParameters.join('&')}`;

  return link;
};
